import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { NEWS_ITEMS } from '../data'

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
}

export default function NewsSection({ limit = 3 }: { limit?: number }) {
  const items = NEWS_ITEMS.slice(0, limit)

  return (
    <section style={{ padding: 'clamp(48px, 8vw, 80px) clamp(16px, 5vw, 32px)', background: 'var(--ink-2)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            marginBottom: '48px',
            paddingBottom: '20px',
            borderBottom: '1px solid var(--border)',
          }}
        >
          <div>
            <div className="section-label">Latest</div>
            <div className="section-title">News</div>
          </div>
          <Link
            to="/news"
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: '10px',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              color: 'var(--gold-dim)',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              borderBottom: '1px solid rgba(122,101,64,0.4)',
              paddingBottom: '2px',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
            onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold-dim)')}
          >
            View All News <ArrowRight size={12} />
          </Link>
        </div>

        {/* News Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '1px',
            background: 'var(--border)',
          }}
        >
          {items.map((item) => (
            <article
              key={item.id}
              style={{
                background: 'var(--ink-2)',
                padding: '28px 24px',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                transition: 'background 0.2s',
              }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.background = '#1a1710')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.background = 'var(--ink-2)')}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <span
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '10px',
                    letterSpacing: '3px',
                    textTransform: 'uppercase',
                    color: 'var(--gold-dim)',
                  }}
                >
                  {formatDate(item.date)}
                </span>
                {item.category && (
                  <span
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: '9px',
                      letterSpacing: '2px',
                      textTransform: 'uppercase',
                      color: 'var(--gold)',
                      border: '1px solid rgba(200,169,110,0.25)',
                      padding: '3px 8px',
                    }}
                  >
                    {item.category}
                  </span>
                )}
              </div>

              <h3
                style={{
                  fontFamily: 'var(--font-serif)',
                  fontSize: '18px',
                  fontWeight: 600,
                  color: 'var(--cream)',
                  lineHeight: 1.4,
                  marginBottom: '12px',
                  flex: 1,
                }}
              >
                {item.title}
              </h3>

              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  lineHeight: 1.7,
                  marginBottom: '20px',
                }}
              >
                {item.excerpt}
              </p>

              <Link
                to={`/news/${item.slug}`}
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '3px',
                  textTransform: 'uppercase',
                  color: 'var(--gold-dim)',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold-dim)')}
              >
                Read More <ArrowRight size={10} />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
